import { styled, TextField, TextFieldProps } from "@mui/material";
import { BORDER_COLORS } from "../../constants";
import { forwardRef } from "react";

const StyledInput = styled(TextField)(({ theme, size }) => ({
  ".MuiOutlinedInput-input": {
    height: size === "small" ? 40 : 56,
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: size === "small" ? 13 : 16,
    [theme.breakpoints.down("lg")]: {
      height: size === "small" ? 40 : 48,
    },
  },
  ".MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: BORDER_COLORS.default,
    transition: "border-color 0.2s linear",
  },
  ".MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: BORDER_COLORS.hover,
  },
  ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderWidth: 2,
    borderColor: BORDER_COLORS.focused,
  },
  "p.Mui-error": {
    marginLeft: 0,
    marginRight: 0,
  },
}));

export const Input = forwardRef<any, TextFieldProps>(
  ({ ...restProps }, ref) => {
    return <StyledInput ref={ref} {...restProps} />;
  },
);
